import script from "./InvisibleCharactersHighlight.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvisibleCharactersHighlight.vue?vue&type=script&setup=true&lang=ts"

import "./InvisibleCharactersHighlight.vue?vue&type=style&index=0&id=1863d5f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1863d5f0"]])

export default __exports__